<template>
  <div>
    <vxe-grid
      ref="TreeTableRef"
      auto-resize
      show-overflow
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="filterList || tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:icon="{ row }">
        <i :class="'el-icon-' + row.funcIcon"></i>
      </template>
      <template v-slot:funcID>
        <filter-content
          :text="$l('form_label_funcID') || '功能编号'"
          :items="funcIDOptions"
          @filter="(e) => (funcIDFilter = e)"
          submitFilterOnClose
        />
      </template>
      <template v-slot:titleText>
        <filter-content
          :text="$l('form_label_titleText') || '功能标题'"
          :items="titleTextOptions"
          @filter="(e) => (titleTextFilter = e)"
          submitFilterOnClose
        />
      </template>
      <template v-slot:classLevel>
        <filter-content
          :text="$l('form_label_classLevel') || '功能层级'"
          :items="classLevelOptions"
          @filter="(e) => (classLevelFilter = e)"
          submitFilterOnClose
        />
      </template>
      <template v-slot:isLast="{ row }">
        <el-tag
          size="mini"
          :type="
            row.isLast === 'Y' ? 'success' : row.isLast === 'N' ? 'warning' : ''
          "
        >
          {{ row.v_isLast }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <el-dropdown trigger="click" @command="chooseFunction">
          <i class="el-icon-arrow-down el-icon--right"></i>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              icon="el-icon-plus"
              :command="{
                pageType: 'add',
                funcID: row.funcID,
                classLevel: row.classLevel,
              }"
              >{{ $l('INDEX.btn_tips_add') || '新增' }}</el-dropdown-item
            >
            <el-dropdown-item
              icon="el-icon-view"
              :command="{
                pageType: 'detail',
                funcID: row.funcID,
                classLevel: row.classLevel,
              }"
              divided
              >{{ $l('INDEX.btn_tips_view') || '查看' }}</el-dropdown-item
            >
            <el-dropdown-item
              icon="el-icon-edit"
              :command="{
                pageType: 'edit',
                funcID: row.funcID,
                classLevel: row.classLevel,
              }"
              divided
              >{{ $l('INDEX.btn_tips_edit') || '编辑' }}</el-dropdown-item
            >
            <el-dropdown-item
              icon="el-icon-delete"
              :command="{
                pageType: 'del',
                funcID: row.funcID,
                classLevel: row.classLevel,
              }"
              divided
              >{{ $l('INDEX.btn_tips_del') || '删除' }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </template>
      <template v-slot:isVisible="{ row }">
        <el-tag
          size="mini"
          :type="
            row.isVisible === 'Y'
              ? 'success'
              : row.isVisible === 'N'
              ? 'warning'
              : ''
          "
        >
          {{ row.v_isVisible }}
        </el-tag>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <el-drawer
      :title="titleText"
      :visible.sync="showDetail"
      :wrapperClosable="false"
      destroy-on-close
      direction="rtl"
      size="1000px"
      v-if="showDetail"
    >
      <TableDetail
        ref="tableDetailRef"
        :pageType="pageType"
        :funcID="funcID"
        :classLevel="classLevel"
        @closeDrawer="closeDrawer"
      ></TableDetail>
    </el-drawer>
  </div>
</template>
<script>
import XEUtils from 'xe-utils'
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
import TableDetail from '../../detail'
export default {
  mixins: [TableAutoHeight],
  components: { TableDetail },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  watch: {
    filterParams: {
      handler() {
        this.filterData()
      },
      deep: true,
    },
  },
  data() {
    return {
      treeConfig: { reserve: true, expandAll: true },
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      filterList: null,
      tableColumns: tableColumns(this),
      showDetail: false,
      titleText: '',
      funcID: '',
      pageType: '',
      indexKey: 1,
      classLevel: 0,
      funcIDFilter: [],
      titleTextFilter: [],
      classLevelFilter: [],
    }
  },
  computed: {
    funcIDOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.funcID).filter(Boolean)))
    },
    titleTextOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.titleText).filter(Boolean)))
    },
    classLevelOptions() {
      const data = this.tableData
      return Array.from(new Set(data.map((i) => i.classLevel).filter(Boolean)))
    },
    filterParams() {
      return {
        funcIDFilter: this.funcIDFilter || [],
        titleTextFilter: this.titleTextFilter || [],
        classLevelFilter: this.classLevelFilter || [],
      }
    },
  },
  methods: {
    filterData() {
      const {
        funcIDFilter,
        titleTextFilter,
        classLevelFilter,
      } = this.filterParams
      let data = this.tableData
      if (funcIDFilter && funcIDFilter.length) {
        data = data.filter((i) => funcIDFilter.includes(i.funcID))
      }
      if (titleTextFilter && titleTextFilter.length) {
        data = data.filter((i) => titleTextFilter.includes(i.titleText))
      }
      if (classLevelFilter && classLevelFilter.length) {
        data = data.filter((i) => classLevelFilter.includes(i.classLevel))
      }
      this.filterList = data
    },
    chooseFunction({ pageType, funcID, classLevel }) {
      let titleText = this.$l('dialog_title_view') || '查看详情'
      switch (pageType) {
        case 'add':
          titleText = this.$l('dialog_title_add') || '新增'
          this.openEditPage(pageType, funcID, titleText, classLevel)
          break
        case 'detail':
          this.openEditPage(pageType, funcID, titleText, classLevel)
          break
        case 'edit':
          titleText = this.$l('dialog_title_edit') || '编辑'
          this.openEditPage(pageType, funcID, titleText, classLevel)
          break
        case 'del':
          this.del(funcID)
          break
        default:
          return
      }
    },
    openEditPage(pageType, funcID, titleText, classLevel) {
      this.titleText = titleText
      this.funcID = funcID
      this.pageType = pageType
      this.classLevel = classLevel
      this.showDetail = true
    },
    closeDrawer() {
      this.showDetail = false
      this.$emit('reload')
    },
    openAddDrawer() {
      this.titleText = '新增'
      this.funcID = ''
      this.pageType = 'add'
      this.classLevel = 0
      this.showDetail = true
    },
    del(code) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.sysMerchantFunctionDelApi({ funcID: code }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.filterList = null
          this.$emit('reload')
        })
      })
    },
    filter(keyword) {
      if (keyword) {
        this.filterList = this.tableData
        const filterName = String(keyword)
          .trim()
          .toLowerCase()
        const filterRE = new RegExp(filterName, 'gi')
        const options = { children: 'children' }
        const searchProps = ['funcID', 'titleText']
        XEUtils.eachTree(
          this.filterList,
          (item) => {
            searchProps.forEach((key) => {
              item[key] = String(item[key]).replace(
                filterRE,
                (match) => `<span class="keyword-lighten">${match}</span>`
              )
            })
          },
          options
        )
      } else {
        this.filterList = this.tableData
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
::v-deep .el-drawer__body {
  overflow: auto !important;
}
</style>
